import * as React from 'react';
import {useState} from 'react';
import Chip from '@mui/material/Chip';
import DoneIcon from '@mui/icons-material/Done';
import {LIVE_EXPIRE_FILTERS, QUESTION_TYPES, SORT_BY} from '../constants/appConstants';
import Divider from '@mui/material/Divider';
import {ListItemIcon, ListItemText, Paper} from '@mui/material';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import PollDropdown from './forms/PollDropdown';

const {POPULAR, RECENT, TOP} = SORT_BY
const {LIVE, EXPIRED} = LIVE_EXPIRE_FILTERS

const Item = styled(Paper)(({theme}) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  // ...theme.typography.body2,
  // padding: theme.spacing(1),
  // textAlign: 'center',
  // color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'left',
  flexWrap: 'nowrap',
  listStyle: 'none',
  padding: theme.spacing(0.5),
  margin: 0,
  overflow: 'auto',
  // maxWidth: "400px"
}));

export default function Filters() {

  const [sortBy, setSortBy] = useState(TOP)
  const [pollStatus, setPollStatus] = useState(LIVE)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };

  const renderSortByChip = (sortByOption, selectedVal, setSelectedVal) => {
    const activeOptions = {}
    if (sortByOption === selectedVal) {
      activeOptions.onDelete = handleDelete;
      activeOptions.color = 'primary';
    } else {
      activeOptions.variant = 'primary';
    }

    return <Chip
      // size={"small"}
      label={sortByOption}
      onClick={() => setSelectedVal(sortByOption)}
      deleteIcon={<DoneIcon/>}
      {...activeOptions}
    />
  }

  const dividerWithSpacing = () => {
    return <Divider orientation="vertical" flexItem sx={{ml: 1, mr: 1}}/>
  }

  const renderMenuDropdown = () => {
    return <Box sx={{minWidth: 100}}>
      <FormControl sx={{minWidth: 100}} size="small">
        <PollDropdown
          label={'Type'}
          object={QUESTION_TYPES}
          // selectedVal={selectedPollType}
          // handleDropdownChangeParent={setSelectedPollType}
        />
      </FormControl>
    </Box>
  }
  const renderMenu = () => {
    return <div><Button
      id="demo-positioned-button"
      aria-controls={open ? 'demo-positioned-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClick}
    >
      Type(All)
    </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <DoneIcon fontSize="small"/>
          </ListItemIcon>
          <ListItemText>All</ListItemText>
        </MenuItem>
        {Object.entries(QUESTION_TYPES).map(([pollType, value]) => {
          return <MenuItem onClick={handleClose}>
            {value}
          </MenuItem>
        })}
      </Menu>
    </div>
  }

  return (
    <>
      <Item>
        {renderSortByChip(TOP, sortBy, setSortBy)}
        {renderSortByChip(RECENT, sortBy, setSortBy)}
        {renderSortByChip(POPULAR, sortBy, setSortBy)}
        {dividerWithSpacing()}
        {renderSortByChip(LIVE, pollStatus, setPollStatus)}
        {renderSortByChip(EXPIRED, pollStatus, setPollStatus)}
        {dividerWithSpacing()}
        {/*{renderMenu()}*/}
        {renderMenuDropdown()}
        {dividerWithSpacing()}
        <Button size="small">Reset</Button>
        {dividerWithSpacing()}
      </Item>
    </>
  );
}
